import { Box, Card, Typography } from '@mui/material';
import { CustomStyles } from '@types';
import styles from './styles';

interface CardWithIconProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
  footer?: React.ReactNode;
  icon?: React.ReactNode;
  cardStyle?: CustomStyles;
}
/**
 * CardWithIcon component displays a card with an optional icon, title, subtitle, and footer.
 * @param props - The properties of the CardWithIcon component.
 * @param props.title - The title of the card.
 * @param props.subtitle - The subtitle or additional information for the card.
 * @param props.footer - The footer content of the card.
 * @param props.icon - The icon to be displayed on the card.
 * @param props.children - The content to be displayed within the card body.
 * @param boolean} props.cardStyle - The custom styles to be applied to the card.
 * @returns {JSX.Element} - The CardWithIcon component.*/
function CardWithIcon({
  title,
  subtitle,
  footer,
  icon,
  children,
  cardStyle = {},
}: CardWithIconProps) {
  return (
    <>
      <Card sx={[styles.cardContainer, cardStyle]}>
        <Box sx={styles.cardHeader}>
          <Box sx={styles.title}>
            {icon && icon}
            {title && <Typography variant='h1'>{title}</Typography>}
          </Box>
          <Box>{subtitle && <Typography>{subtitle}</Typography>}</Box>
        </Box>
        <Box>{children}</Box>
        {footer && footer}
      </Card>
    </>
  );
}

export default CardWithIcon;
